module.exports = __webpack_public_path__ + "static/media/SentrySafe_Store_logo.eb2b01b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/SentrySafe_Store_logo.png
// module id = 1173
// module chunks = 0